import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  allTahsilatCustomers: {},
  filteredTahsilatCustomers: [],
  serachedTahsilatCustomers: [],
}

const tahsilatSlice = createSlice({
  name: 'tahsilatCustomers',
  initialState,
  reducers: {
    setAllTahsilatCustomers(state: any, action: {payload: {Detail: any[]; Status: string}}) {
      state.allTahsilatCustomers = action.payload.Detail
    },
    setFilteredTahsilatCustomer(state: any, action: {payload: any}) {
      state.filteredTahsilatCustomers = action.payload
    },
    setSearchedTahsilatCustomers(state: any, action: {payload: any}) {
      state.searchedTahsilatCustomers = action.payload
    },
  },
})

export const {setAllTahsilatCustomers, setFilteredTahsilatCustomer, setSearchedTahsilatCustomers} =
  tahsilatSlice.actions
export default tahsilatSlice.reducer
